module.exports = __webpack_public_path__ + "img/file.5b3e1974.svg";